'use strict'
// Template version: 1.2.5
// see http://vuejs-templates.github.io/webpack for documentation.

// const path = require('path');

module.exports = {
  dev: {

    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},

    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false,
    urlServer: 'http://localhost:8000/',
    urlServerVocational: 'http://localhost:8001/',
    urlServerFamilial: 'http://localhost:8002/',
    urlServerFinancial: 'http://localhost:8003/',
    urlServerSocial: 'http://localhost:8004/',
    urlServerPhysical: 'http://localhost:8005/',
    urlServerMental: 'http://localhost:8006/',
    urlServerSpiritual: 'http://localhost:8007/',
    url: 'http://0.0.0.0:8080',
  },

  build: {
    // Template for index.html
    //index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    //assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    // assetsPublicPath: path.resolve(__dirname, '../dist'),

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    //
    bundleAnalyzerReport: false,
    urlServer: 'https://theorangegirl.com:8000/',
    urlServerVocational: 'https://theorangegirl.com:8001/',
    urlServerFamilial: 'https://theorangegirl.com:8002/',
    urlServerFinancial: 'https://theorangegirl.com:8003/',
    urlServerSocial: 'https://theorangegirl.com:8004/',
    urlServerPhysical: 'https://theorangegirl.com:8005/',
    urlServerMental: 'https://theorangegirl.com:8006/',
    urlServerSpiritual: 'https://theorangegirl.com:8007/',
    url: 'https://theorangegirl.com',
  },
  prodlocal: {
    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    // Template for index.html
    //index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    //assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    // assetsPublicPath: path.resolve(__dirname, '../dist'),

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    // devtool: '#source-map',
    devtool: 'eval-source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    //
    bundleAnalyzerReport: false,
    urlServer: 'http://localhost:8000/',
    urlServerVocational: 'http://localhost:8001/',
    urlServerFamilial: 'http://localhost:8002/',
    urlServerFinancial: 'http://localhost:8003/',
    urlServerSocial: 'http://localhost:8004/',
    urlServerPhysical: 'http://localhost:8005/',
    urlServerMental: 'http://localhost:8006/',
    urlServerSpiritual: 'http://localhost:8007/',
    url: 'http://0.0.0.0:8080',
  }
}
